import "./cardDefault.css";

function CardDefault({ titulo, texto, img }) {
  return (
    <div className="col-md-4 animated animatedFadeInUp fadeInUp">
      <div className="CardDefault text-center p-20">
        <img src={img} alt={titulo} />
        <h2 className="titulo-card">{titulo}</h2>
        <p className="Card-Text-Default">{texto}</p>
      </div>
    </div>
  );
}

export default CardDefault;
